import cls from 'classnames';

const PageWidthConstraint = ({ children, noPadding = false, className = '' }) => (
  <div className={cls(`w-full max-w-screen-2xl`, noPadding ? '' : 'px-4 sm:px-8 lg:px-10 2xl:px-20', className)}>{children}</div>
);

export default PageWidthConstraint;
